import { WorkHistoryIcon } from '@hugeicons/core-free-icons';
import { History } from 'views/Check/tabs/History/History';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';

export const CandidateHistory = ({
  candidate,
  company,
  referees,
  user,
  companyChecks,
  show = false,
  onClose = () => {},
}) => {
  return (
    show &&
    candidate && (
      <AnimatedModal
        visible={show}
        onClose={onClose}
        icon={WorkHistoryIcon}
        oldIconLibrary={false}
        title={`${candidate?.name} history`}
        className="readonly-modal"
        fullscreen={false}>
        <History
          company={company}
          candidate={candidate}
          referees={referees}
          user={user}
          companyChecks={companyChecks}
          readOnly
        />
      </AnimatedModal>
    )
  );
};
